import React, { useEffect, useRef } from 'react'
import { i18nText } from '../../../Services';

export const Select = props => {
    const { context, element, modelPath, type } = props;
    const inputModel = context.readModel(modelPath, element.defaultValue || []);
    const inputValue = inputModel.value || [];
    let inputRef = useRef(null);

    const selectOptions = element.options && element.options.map(i => <option key={i.value} value={i.value} > {i18nText.getText(i.text)} </option>);

    const change = () => {
        const values = getValues();
        const errors = context.validateElement(inputRef.current, element, values);
        context.updateModel(modelPath, values, errors);
    }

    const getValues = () => {
        const options = inputRef.current.options;
        let values = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                values = [...values, options[i].value];
            }
        }
        return values;
    }

    useEffect(() => {
        context.validators.subscribe(change);
        return () => context.validators.unsubscribe(change);        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context, element, modelPath, inputRef]);

    return (
        <select
            type={type}
            ref={inputRef}
            className={"form-control" + (inputModel.errors.length !== 0 ? " is-invalid" : "") + (element.className ? " " + element.className : "")}
            disabled={context.isReadOnly}
            name={element.name}
            onChange={change}
            onFocus={change}
            required={element.required}
            multiple={element.multiple}
            value={element.multiple ? inputValue : inputValue.length === 0 ? "" : inputValue[0]}
        >{selectOptions}</select>
    )
}

export default Select;